module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), (!_vm.emailSent) ? _c('div', {
    staticClass: "text-center col-md-4 col-md-offset-4"
  }, [_c('vue-form', {
    staticClass: "ui form",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendResetLink($event)
      }
    }
  }, [_c('validate', {
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        email: _vm.emailValidator
      }
    }
  }, [_c('vue-form-input', {
    staticClass: "input-group",
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'email',
      "name": 'email',
      "placeholder": 'Email',
      "messages": {
        required: 'This field is required',
        email: 'Please input a valid email'
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.formstate.$dirty || _vm.formstate.$invalid
    }
  }, [_vm._v("Request Link")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.accountActive && _vm.emailSent) ? _c('div', {
    staticClass: "content-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("\n              Proceed to Login\n            ")])])], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Forgot Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15a5c564"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/login/ForgotPassword.vue
// module id = 1949
// module chunks = 1